import type { SVGProps } from "react";

/**
 * The M7 Agents mark: a prompt caret in a sharp frame.
 *
 * It used to be a sparkle, which was wrong twice over. DESIGN.md asks the
 * product not to read as generically "AI-powered", and the sparkle is the
 * single most common way to do exactly that — every assistant in every product
 * wears it. It was also literally the same icon as Trends' Recreate action, so
 * two unrelated things shared one symbol.
 *
 * PRODUCT.md calls this surface "a command and reasoning surface". So the mark
 * is the command prompt itself, which is also what the composer already shows
 * at the head of its input — the rail icon and the thing you type into now
 * carry the same glyph.
 */
export default function AgentMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="square"
      strokeLinejoin="miter"
      {...props}
    >
      <rect x="3" y="4" width="18" height="16" />
      <path d="m8 10 2.6 2.6L8 15.2" />
      <path d="M13.4 15.2h3.2" />
    </svg>
  );
}
